import { AsYouType } from 'libphonenumber-js'
import type { CountryCode } from 'libphonenumber-js'

/** Formats a national number as it is typed: "2025550199" becomes "(202) 555-0199". */
export const formatNationalNumber = (value: string, country: string) => {
	const digits = value.replace(/\D/g, '')
	try {
		return new AsYouType(country.toUpperCase() as CountryCode).input(digits)
	} catch {
		return digits
	}
}
